import {IProgramsNewService} from './IProgramsNewService';
import {ProgramsNewRepository} from './ProgramsNewRepository';
import type {
  CreateNewProgramInput,
  UpdateNewProgramInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/program/graphql/program.interface';

export class ProgramsNewService implements IProgramsNewService {
  programsNewRepository: ProgramsNewRepository;

  constructor() {
    this.programsNewRepository = new ProgramsNewRepository();
  }

  async getNewPrograms(): Promise<any[]> {
    const programs = await this.programsNewRepository.getNewPrograms();
    return programs;
  }

  async getNewProgramById(programId: string): Promise<any> {
    const program = await this.programsNewRepository.getNewProgramById(programId);
    return program;
  }

  async createNewProgram(program: CreateNewProgramInput): Promise<any> {
    const createdProgram = await this.programsNewRepository.createNewProgram(program);
    return createdProgram;
  }

  async updateNewProgram(program: UpdateNewProgramInput): Promise<any> {
    const updatedProgram = await this.programsNewRepository.updateNewProgram(program);
    return updatedProgram;
  }

  async softDeleteNewProgram(programId: string): Promise<boolean> {
    const result = await this.programsNewRepository.softDeleteNewProgram(programId);
    return result;
  }
}
